export default __webpack_public_path__ + "static/media/video_img.c373d8a8.png";